import { TestModeLabel } from 'libs/common-lib/src/lib/services/test-list/types';

export const DSCP_FLOWS = [
  {
    value: 'Best effort (0)',
    id: 0
  },
  {
    value: 'Class Selector 1 (8)',
    id: 32
  },
  {
    value: 'AF 11 (10)',
    id: 40
  },
  {
    value: 'AF 12 (12)',
    id: 48
  },
  {
    value: 'AF 13 (14)',
    id: 56
  },
  {
    value: 'Class Selector 2 (16)',
    id: 64
  },
  {
    value: 'AF 21 (18)',
    id: 72
  },
  {
    value: 'AF 22 (20)',
    id: 80
  },
  {
    value: 'AF 23 (22)',
    id: 88
  },
  {
    value: 'Class Selector 3 (24)',
    id: 96
  },
  {
    value: 'AF 31 (26)',
    id: 104
  },
  {
    value: 'AF 32 (28)',
    id: 112
  },
  {
    value: 'AF 33 (30)',
    id: 120
  },
  {
    value: 'Class Selector 4 (32)',
    id: 128
  },
  {
    value: 'AF 41 (34)',
    id: 136
  },
  {
    value: 'AF 42 (36)',
    id: 144
  },
  {
    value: 'AF 43 (38)',
    id: 152
  },
  {
    value: 'Class Selector 5 (40)',
    id: 160
  },
  {
    value: 'AF 51 (42)',
    id: 168
  },
  {
    value: 'AF 52 (52)',
    id: 176
  },
  {
    value: 'Exp. Forwarding (46)',
    id: 184
  },
  {
    value: 'Class Selector 6 (48)',
    id: 192
  },
  {
    value: 'Class Selector 7 (56)',
    id: 224
  }
];

export const TEST_MODES = [
  { name: TestModeLabel.CLIENT_TO_MA, value: TestModeLabel.CLIENT_TO_MA },
  { name: TestModeLabel.MA_TO_MA, value: TestModeLabel.MA_TO_MA },
  { name: TestModeLabel.MA_TO_JMEP, value: TestModeLabel.MA_TO_JMEP }
];

export const TCP_PORT = [{ name: 'First Available', value: '0' }];
export const QOS_TYPE = [
  { name: 'DSCP', value: 'dscp' },
  { name: 'ToS', value: 'tos' }
];
export const CONNECTION_DATA = [
  { name: 'Automatic', value: 'auto' },
  { name: 'Manual', value: 'manual' }
];

export const EXPIRATION_TIME = [
  { name: '1 Hr', value: '1hour' },
  { name: '2 Hr', value: '2hour' },
  { name: '6 Hr', value: '6hour' },
  { name: '12 Hr', value: '12hour' },
  { name: '1 Day', value: '1day' },
  { name: '2 Days', value: '2days' },
  { name: '7 Days', value: '7days' },
  { name: 'Unlimited', value: 'Unlimited' }
];

export interface IEngineInfo {
  'engine-type': string;
  address: string;
  port: string;
  'test-ip': string;
  'test-subnet-mask': string;
  'test-gateway': string;
}

export enum definedAddressLabel {
  TEST_IP = 'Test IP',
  MANAGEMENT_IP = 'Management IP',
  MANUAL = 'Manual'
}

export enum definedAddressValue {
  TEST_IP = 'testIP',
  MANAGEMENT_IP = 'managed',
  MANUAL = 'manual'
}

export enum TRANSMIT_INTERFACE_LABEL {
  EQUIPMENT = 'Equipment',
  NETWORK = 'Network'
}

export enum TRANSMIT_INTERFACE_VALUE {
  EQUIPMENT = 'equipment',
  NETWORK = 'network'
}

export enum TX_IMAGE {
  EQUIPMENT = 'images/equipment.png',
  NETWORK = 'images/network.png'
}

export const TRANSMIT_INTERFACE_TYPE = [
  { name: TRANSMIT_INTERFACE_LABEL.EQUIPMENT, value: TRANSMIT_INTERFACE_VALUE.EQUIPMENT },
  { name: TRANSMIT_INTERFACE_LABEL.NETWORK, value: TRANSMIT_INTERFACE_VALUE.NETWORK }
];

export const DEFINED_ADDRESS_TYPES = [
  { name: definedAddressLabel.TEST_IP, value: definedAddressValue.TEST_IP, enabled: true },
  {
    name: definedAddressLabel.MANAGEMENT_IP,
    value: definedAddressValue.MANAGEMENT_IP,
    enabled: true
  }
];

export const SUBNET_MAP = {
  '1': '128.0.0.0',
  '2': '192.0.0.0',
  '3': '224.0.0.0',
  '4': '240.0.0.0',
  '5': '248.0.0.0',
  '6': '252.0.0.0',
  '7': '254.0.0.0',
  '8': '255.0.0.0',
  '9': '255.128.0.0',
  '10': '255.192.0.0',
  '11': '255.224.0.0',
  '12': '255.240.0.0',
  '13': '255.248.0.0',
  '14': '255.252.0.0',
  '15': '255.254.0.0',
  '16': '255.255.0.0',
  '17': '255.255.128.0',
  '18': '255.255.192.0',
  '19': '255.255.224.0',
  '20': '255.255.240.0',
  '21': '255.255.248.0',
  '22': '255.255.252.0',
  '23': '255.255.254.0',
  '24': '255.255.255.0',
  '25': '255.255.255.128',
  '26': '255.255.255.192',
  '27': '255.255.255.224',
  '28': '255.255.255.240',
  '29': '255.255.255.248',
  '30': '255.255.255.252',
  '31': '255.255.255.254',
  '32': '255.255.255.255'
};

export const TruespeedConfigFieldMapping = {
  ALIAS: 'alias',
  CUSTOMER: 'customer',
  CONTACT: 'contact',
  EMAIL: 'email',
  PHONE: 'phone',
  TECHINICIAN: 'technician',
  TECHINICIANID: 'technicianId',
  COMMENTS: 'comments',
  UPSTREAM_CIR: 'engine-b-to-a-cir',
  DOWNSTREAM_CIR: 'engine-a-to-b-cir',
  UPSTREAM_THRESHOLD: 'engine-b-to-a-threshold',
  DOWNSTREAM_THRESHOLD: 'engine-a-to-b-threshold',
  ENGINE_A_INFO: 'engine-a-info',
  ENGINE_B_INFO: 'engine-b-info',
  SHA_ID: 'shaId',
  TEST_MODE: 'testMode',
  RUN_TYPE: 'runType',
  AGENT_TYPE: 'agentType',
  SCHEDULER: 'scheduler',
  DSCP: 'tos-dscp',
  TCP_PORT: 'tcp-port',
  RUN_EXCLUSIVE: 'run-exclusive',
  EXPIRATION_DEFAULT_VALUE: 'expiration-default-value',
  EXPIRATION_DATE: 'expiration-date',
  MAX_EXECUTION_COUNTS: 'max-execution-counts',
  STARTING_PERCENT: 'percent-start-window-walk',
  NUMBER_OF_WALKS: 'num-windows',
  WINDOW_DURATION: 'window-duration',
  CONNECTIONS: 'connections',
  SATURATION: 'run-saturation-window',
  ENABLE_DYNAMIC_SATURATION: 'dynamic-saturation',
  BOOST_WINDOW_PERCENT: 'percent-over-saturate-window',
  BOOST_CONNECTION_PERCENT: 'percent-over-saturate-connections',
  SELECTED_ORIGINATOR: 'selectedOriginator',
  SELECTED_DESTINATION: 'selectedDestination',
  DESTINATION_IP: 'destination-ip',

  //Source endpoint
  SRC_DEFINED_ADDRESS: 'definedAddress',
  SRC_MAC_ADDRESS: 'source-mac',
  SRC_NETWORK_MAC: 'srcNetworkMacAddress',
  SRC_EQUIPMENT_MAC: 'srcEquipmentMacAddress',
  SRC_TEST_IP_ADDRESS: 'test-ip',
  SRC_ASSIGNED_IP_ADDRESS: 'srcAssignedIpAddress',
  SRC_SUBNET: 'test-subnet-mask',
  SRC_GATEWAY: 'test-gateway',
  SRC_TRANSMIT_INTERFACE: 'tx-interface',
  SRC_VLAN_ID: 'test-vlan-id',

  //Destination Endpoint
  DEST_AGENT_TYPE: 'dest-agentType',
  DEST_DEFINED_ADDRESS: 'destDefinedAddress',
  DEST_MAC_ADDRESS: 'dest-mac',
  DEST_NETWORK_MAC: 'destNetworkMacAddress',
  DEST_EQUIPMENT_MAC: 'destEquipmentMacAddress',
  DEST_TEST_IP_ADDRESS: 'dest-test-ip',
  DEST_ASSIGNED_IP_ADDRESS: 'destAssignedIpAddress',
  DEST_SUBNET: 'dest-test-subnet-mask',
  DEST_GATEWAY: 'dest-test-gateway',
  DEST_TRANSMIT_INTERFACE: 'dest-tx-interface',
  DEST_VLAN_ID: 'dest-test-vlan-id'
};
